import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const financeSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    setError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = null;
      state.success = true;
    },
    resetFinance: (state) => initialState,
  },
});

export const { setLoading, setError, setSuccess, resetFinance } = financeSlice.actions;
export default financeSlice.reducer;
